import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from './Header';
import api from '../api/api';

// Utility function to highlight text in dropdown options
const highlightText = (text = "", search = "") => {
  if (!search) return text;

  const regex = new RegExp(`(${search})`, "ig");
  const parts = text.split(regex);

  return parts.map((part, i) =>
    part.toLowerCase() === search.toLowerCase() ? (
      <span
        key={i}
        className="bg-yellow-200 text-black font-semibold rounded px-0.5"
      >
        {part}
      </span>
    ) : (
      part
    )
  );
};

// Utility function to format the current date for date input (YYYY-MM-DD)
const getCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};


export default function OrderForm() {
   const navigate = useNavigate();
   const location = useLocation();

  const handleLogout = () => {
    sessionStorage.removeItem("isLoggedIn");
    sessionStorage.removeItem("username");
    sessionStorage.removeItem("lastVisited");
    navigate("/");
  };

  const [state, setState] = useState({
    mealType: "Breakfast",
    orderDate: getCurrentDate(),
    selectedCustomer: '',
    phone1: '',
    phone2: '',
    address: '',
    area: '',
    route1: '',
    route2: '',
    payMode: ''
  });

  const [selectedCustomerObj, setSelectedCustomerObj] = useState(null);

  const [customers, setCustomers] = useState([]);
  const [paymentModes, setPaymentModes] = useState([]);
  const [items, setItems] = useState([]);
  const [packTypes, setPackTypes] = useState([]);
  const [itemDesc, setItemDesc] = useState('');
  const [orderItems, setOrderItems] = useState([]);
  const [qty, setQty] = useState(1);
  const [rate, setRate] = useState('');
  const [adlDC, setAdlDC] = useState('');
  const [packType, setPackType] = useState('');
  const [strictPacktype, setStrictPacktype] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [transNo, setTransNo] = useState('');
  const [prePaidAmt, setPrePaidAmt] = useState(0);
  const [nextDays, setNextDays] = useState(1);
  const [searchTextCustomer, setSearchTextCustomer] = useState('');
  const [dropdownOpenCustomer, setDropdownOpenCustomer] = useState(false);
  const [searchTextPaymode, setSearchTextPaymode] = useState('');
  const [dropdownOpenPaymode, setDropdownOpenPaymode] = useState(false);
  const [searchTextItem, setSearchTextItem] = useState('');
  const [dropdownOpenItem, setDropdownOpenItem] = useState(false);
  const dropdownRefCustomer = useRef(null);
  const dropdownRefPaymode = useRef(null);
  const dropdownRefItem = useRef(null);
  const listRefCustomer = useRef(null);
  const listRefPaymode = useRef(null);
  const listRefItem = useRef(null);
  const username = sessionStorage.getItem("username") || "UnknownUser";
  const [activeIndexCustomer, setActiveIndexCustomer] = useState(-1);
  const [activeIndexPaymode, setActiveIndexPaymode] = useState(-1);
  const [activeIndexItem, setActiveIndexItem] = useState(-1);
  const [isEdit, setIsEdit] = useState(false);
  const [orId, setOrId] = useState(null);
  const getSelectedCustomer = () => isEdit ? selectedCustomerObj : (customers.find(c => c.Vname === state.selectedCustomer) || {});

  const removeItem = (index) => {
  setOrderItems(prev => prev.filter((_, i) => i !== index));
};

 const filteredCustomers = customers.filter(c => {
  const search = searchTextCustomer.toLowerCase().trim();

  const combined = `${c.VCode ?? ''} ${c.Vname ?? ''}`.toLowerCase();

  return combined.includes(search);
});

  const filteredPaymodes = paymentModes.filter(m =>
    (m.Mode || '').toLowerCase().includes(searchTextPaymode.toLowerCase())
  );

  const filteredItems = items.filter(i =>
    (i.Item_desc1 || '').toLowerCase().includes(searchTextItem.toLowerCase())
  );

  useEffect(() => {
    const handleKeyShortcuts = (e) => {
      if (e.key === "F4") {
        e.preventDefault();          // Stop browser refresh
        navigate("/orderformexplorer");      // Open new order page
      }
    };
  
    window.addEventListener("keydown", handleKeyShortcuts);
  
    return () => window.removeEventListener("keydown", handleKeyShortcuts);
  }, [navigate]);
  

  useEffect(() => {
  if (packTypes.length > 0) {
    const defaultPack =
      packTypes.find(p => p.packdesc?.toLowerCase() === "N/A") ||
      packTypes[0];

    setPackType(defaultPack.packdesc);
  }
}, [packTypes]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.GenFdOrdvaluesAPI(username, '1');
        if (response.GenFdOrdvaluesAPIjs) {
          setCustomers(response.GenFdOrdvaluesAPIjs.Table || []);
          setPaymentModes(response.GenFdOrdvaluesAPIjs.Table2 || []);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (location.state?.editData) {
      const { Table, Table1 } = location.state.editData;
      if (Table && Table.length > 0) {
        const order = Table[0];
        setIsEdit(true);
        setOrId(order.OrId);
        setSelectedCustomerObj({
          Vid: order.Vid,
          VCode: order.Vcode,
          Vname: order.Vname,
          Mobile: order.Mobile,
          Phone: order.Phone,
          Address1: order.Address1,
          Area: order.Area,
          Route1: order.Route1,
          Route2: order.Route2
        });
        setState({
          mealType: 'Breakfast', // default, or from items
          orderDate: order.StartDate?.split('T')[0] || getCurrentDate(),
          selectedCustomer: order.Vname,
          phone1: order.Mobile,
          phone2: order.Phone,
          address: order.Address1,
          area: order.Area,
          route1: order.Route1,
          route2: order.Route2,
          payMode: order.Paymode
        });
        setSearchTextCustomer(order.Vname);
        setSearchTextPaymode(order.Paymode);
        setTransNo(order.TransNo || '');
        setPrePaidAmt(order.PrePaidAmt || 0);
        setNextDays(order.Nextdays || 1);
        if (Table1 && Table1.length > 0) {
          const items = Table1.map(item => ({
            ItemId: item.Itemid,
            food: item.FoodType,
            item: item.Item,
            desc: item.Item_desc,
            qty: item.Qty,
            rate: item.StandardCost,
            total: item.Qty * item.StandardCost,
            adlDC: item.AdlDc,
            packType: item.packdesc || '',
            strictPacktype: item.StrictPacktype,
            notes: item.notes || ''
          }));
          setOrderItems(items);
        }
      }
    }
  }, [location.state]);

  useEffect(() => {
    const fetchItems = async () => {
      if (state.selectedCustomer) {
        try {
          const response = await api.GetItemvaluesAPI(getSelectedCustomer().Vid, username, state.mealType, getSelectedCustomer().Mobile || '');
          if (response.GetItemvaluesAPIjs) {
            setItems(response.GetItemvaluesAPIjs.Table || []);
          }
        } catch (error) {
          console.error('Error fetching items:', error);
        }
      }
    };
    fetchItems();
  }, [state.mealType, state.selectedCustomer]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRefCustomer.current && !dropdownRefCustomer.current.contains(event.target)) {
        setDropdownOpenCustomer(false);
        setActiveIndexCustomer(-1);
      }
      if (dropdownRefPaymode.current && !dropdownRefPaymode.current.contains(event.target)) {
        setDropdownOpenPaymode(false);
        setActiveIndexPaymode(-1);
      }
      if (dropdownRefItem.current && !dropdownRefItem.current.contains(event.target)) {
        setDropdownOpenItem(false);
        setActiveIndexItem(-1);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Auto scroll for customer dropdown
  useEffect(() => {
    if (listRefCustomer.current && activeIndexCustomer >= 0) {
      const item = listRefCustomer.current.children[activeIndexCustomer];
      item?.scrollIntoView({ block: "nearest" });
    }
  }, [activeIndexCustomer]);

  // Auto scroll for paymode dropdown
  useEffect(() => {
    if (listRefPaymode.current && activeIndexPaymode >= 0) {
      const item = listRefPaymode.current.children[activeIndexPaymode];
      item?.scrollIntoView({ block: "nearest" });
    }
  }, [activeIndexPaymode]);

  // Auto scroll for item dropdown
  useEffect(() => {
    if (listRefItem.current && activeIndexItem >= 0) {
      const item = listRefItem.current.children[activeIndexItem];
      item?.scrollIntoView({ block: "nearest" });
    }
  }, [activeIndexItem]);

  const calculateNetTotal = () => {
    return orderItems.reduce((s, i) => s + i.total, 0);
  };

  const setMealType = (type) => {
    setState(prev => ({ ...prev, mealType: type }));
    setSearchTextItem('');
    setItemDesc('');
    setRate('');
    setAdlDC('');
    // setPackTypes([]);
    setDropdownOpenItem(false);
  };

  const setOrderDate = (date) => {
    setState(prev => ({ ...prev, orderDate: date }));
  };

  const updateNotes = (index, notes) => {
    setOrderItems(prev => prev.map((item, i) => i === index ? { ...item, notes } : item));
  };

  const updateQty = (index, qty) => {
    const newQty = parseInt(qty) || 0;
    setOrderItems(prev => prev.map((item, i) => i === index ? { ...item, qty: newQty, total: newQty * (parseFloat(item.rate) || 0) } : item));
  };

  const handleKeyDownCustomer = (e) => {
    const options = filteredCustomers;
    if (!dropdownOpenCustomer && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
      setDropdownOpenCustomer(true);
      setActiveIndexCustomer(0);
      return;
    }

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setActiveIndexCustomer(i => i < options.length - 1 ? i + 1 : 0);
        break;
      case "ArrowUp":
        e.preventDefault();
        setActiveIndexCustomer(i => i > 0 ? i - 1 : options.length - 1);
        break;
      case "Enter":
        if (dropdownOpenCustomer && activeIndexCustomer >= 0) {
          e.preventDefault();
          const selected = options[activeIndexCustomer];
          if (selected) {
            setSelectedCustomerObj(selected);
            setState(prev => ({...prev, selectedCustomer: selected.Vname}));
            setSearchTextCustomer(`${selected.VCode} - ${selected.Vname}`);
            setDropdownOpenCustomer(false);
            setActiveIndexCustomer(-1);
          }
        }
        break;
      case "Escape":
        setDropdownOpenCustomer(false);
        setActiveIndexCustomer(-1);
        break;
      default:
        break;
    }
  };

  const handleKeyDownPaymode = (e) => {
    const options = filteredPaymodes;
    if (!dropdownOpenPaymode && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
      setDropdownOpenPaymode(true);
      setActiveIndexPaymode(0);
      return;
    }

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setActiveIndexPaymode(i => i < options.length - 1 ? i + 1 : 0);
        break;
      case "ArrowUp":
        e.preventDefault();
        setActiveIndexPaymode(i => i > 0 ? i - 1 : options.length - 1);
        break;
      case "Enter":
        if (dropdownOpenPaymode && activeIndexPaymode >= 0) {
          e.preventDefault();
          const selected = options[activeIndexPaymode];
          if (selected) {
            setState(prev => ({...prev, payMode: selected.Mode}));
            setSearchTextPaymode(selected.Mode);
            setDropdownOpenPaymode(false);
            setActiveIndexPaymode(-1);
          }
        }
        break;
      case "Escape":
        setDropdownOpenPaymode(false);
        setActiveIndexPaymode(-1);
        break;
      default:
        break;
    }
  };

  const handleKeyDownItem = (e) => {
    const options = filteredItems;
    if (!dropdownOpenItem && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
      setDropdownOpenItem(true);
      setActiveIndexItem(0);
      return;
    }

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setActiveIndexItem(i => i < options.length - 1 ? i + 1 : 0);
        break;
      case "ArrowUp":
        e.preventDefault();
        setActiveIndexItem(i => i > 0 ? i - 1 : options.length - 1);
        break;
      case "Enter":
        if (dropdownOpenItem && activeIndexItem >= 0) {
          e.preventDefault();
          const selected = options[activeIndexItem];
          if (selected) {
            setSelectedItem(selected);
            setSearchTextItem(selected.Item);
            setItemDesc(selected.Item_desc1);
            setRate(selected.StandardCost);
            setAdlDC(selected.DCAPPLY);
            setDropdownOpenItem(false);
            setActiveIndexItem(-1);
            // Fetch pack types
            (async () => {
              try {
                const response = await api.GetpackTypevaluesAPI(selected.ItemId, 1, username);
                if (response.GetpackTypevaluesAPIjs) {
                  setPackTypes(response.GetpackTypevaluesAPIjs.Table || []);
                }
              } catch (error) {
                console.error('Error fetching pack types:', error);
              }
            })();
          }
        }
        break;
      case "Escape":
        setDropdownOpenItem(false);
        setActiveIndexItem(-1);
        break;
      default:
        break;
    }
  };

  const updateRate = (index, rate) => {
    const newRate = parseFloat(rate) || 0;
    setOrderItems(prev => prev.map((item, i) => i === index ? { ...item, rate: newRate, total: (parseInt(item.qty) || 0) * newRate } : item));
  };

  const renderHeader = () => {
    return (
    <div className="mb-3 flex items-center justify-between rounded-2xl bg-orange-500 p-2 text-white shadow-xl">
        <button
          onClick={() => navigate('/orderformexplorer')}
           className="inline-flex items-center gap-1 px-3 py-1 text-gray-800 font-semibold
                 bg-gray-200 hover:bg-gray-300 rounded-full shadow transition
                 text-sm sm:text-base w-auto self-start"
            >
          ← Back
        </button>
        <h1 className="text-2xl font-bold text-center flex-1">{isEdit ? 'Edit Order' : 'New Order'}</h1>
        <div className="flex gap-4 text-sm font-medium opacity-90">
          <button
          onClick={async () => {
            const payload = {
              Sp_SqlAction: isEdit ? "Update" : "Insert",
              ...(isEdit && { OrId: orId }),
              Vid: getSelectedCustomer().Vid,
              Vcode: getSelectedCustomer().Mobile,
              Vname: state.selectedCustomer,
              Address1: getSelectedCustomer().Address1,
              Mobile: getSelectedCustomer().Mobile,
              Phone: getSelectedCustomer().Phone || '',
              Area: getSelectedCustomer().Area,
              Route1: getSelectedCustomer().Route1,
              Route2: getSelectedCustomer().Route2,
              StartDate: state.orderDate + 'T00:00:00',
              Nextdays: nextDays,
              Username: username,
              AreaId: 1,
              Paymode: state.payMode,
              TransNo: transNo,
              PrePaidAmt: prePaidAmt,
              Items: orderItems.map(i => ({
                Itemid: i.ItemId,
                Item: i.item,
                FoodType: i.food,
                item_desc: i.desc,
                Qty: i.qty,
                Packid: packTypes.find(p => p.packdesc === i.packType)?.packid,
                Pack_desc: i.packType,
                notes: i.notes,
                StrictPacktype: i.strictPacktype,
                StandardCost: i.rate,
                AdlDc: i.adlDC
              }))
            };
            try {
              const response = await api.FdOrderSaveAPI(payload);
             const result = response?.FdOrderSaveAPIjs?.Table?.[0];

if (result?.Ordid) {
  const action = isEdit ? 'updated' : 'saved';
  alert(`Order ${action} successfully!`);
  navigate('/orderformexplorer');
  //navigate('/orderformexplorer');
}
            } catch (error) {
              console.error('Error saving order:', error);
              alert('Failed to save order.');
            }
          }}
          className="rounded-lg bg-white px-4 py-2 text-orange-500 font-semibold shadow-md transition duration-150 hover:bg-slate-50"
        >
          {isEdit ? 'Update' : 'Save'}
        </button>
          <button onClick={() => navigate('/orderformexplorer')} className="rounded-lg border border-white px-4 py-2 text-white font-semibold transition duration-150 hover:bg-white hover:text-orange-500">Close</button>
        </div>
      </div>
    );
  };

  const renderCustomerPayment = () => {
    return (
      <div className="grid gap-3 lg:grid-cols-2">
        <div className="rounded-2xl bg-white p-3 shadow-md">
          <h2 className="mb-4 text-lg font-semibold border-b pb-1 text-orange-600">Customer Details</h2>
          <div className="space-y-2">
              <div className="relative w-full" ref={dropdownRefCustomer}>
                <label className="block mb-1 font-semibold text-gray-700">Customer</label>
                <input
                  type="text"
                  value={searchTextCustomer}
                  onChange={(e) => {
                    setSearchTextCustomer(e.target.value);
                    setDropdownOpenCustomer(true);
                    setActiveIndexCustomer(-1);
                  }}
                  onClick={() => setDropdownOpenCustomer(!dropdownOpenCustomer)}
                  onKeyDown={handleKeyDownCustomer}
                  placeholder="Search by customer code or name..."
                  className="w-full px-4 py-2 border rounded-md cursor-pointer focus:ring-2 focus:ring-orange-300 bg-slate-50"
                />
                {dropdownOpenCustomer && (
                  <ul ref={listRefCustomer} className="absolute z-10 w-full mt-1 overflow-y-auto bg-white border rounded-md shadow-lg max-h-60">
                    {filteredCustomers?.length > 0 ? (
                      filteredCustomers.map((c, index) => (
                        <li
                          key={`${c.Vid}-${c.VCode}`}
                          onClick={() => {
                            setSelectedCustomerObj(c);
                            setState(prev => ({...prev, selectedCustomer: c.Vname}));
                            setSearchTextCustomer(`${c.VCode} - ${c.Vname}`);
                            setDropdownOpenCustomer(false);
                            setActiveIndexCustomer(-1);
                          }}
                          onMouseEnter={() => setActiveIndexCustomer(index)}
                          className={`px-4 py-2 cursor-pointer ${
                            index === activeIndexCustomer
                              ? "bg-gray-100 font-semibold"
                              : "hover:bg-orange-100"
                          }`}
                        >
                          {highlightText(`${c.VCode} - ${c.Vname}`, searchTextCustomer)}
                        </li>
                      ))
                    ) : (
                      <li className="px-4 py-2 text-gray-500">No customers found</li>
                    )}
                  </ul>
                )}
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <input className="rounded-lg border border-slate-300 p-2 py-1.5 bg-slate-50 focus:outline-none" value={getSelectedCustomer().Mobile} placeholder="Primary Phone" readOnly />
                  <input
                      className="rounded-lg border border-slate-300 p-2 py-1.5 focus:border-orange-500 focus:ring-1 focus:ring-orange-500"
                      value={getSelectedCustomer().Phone}
                      onChange={(e) => setState(prev => ({...prev, phone2: e.target.value}))}
                      placeholder="Secondary Phone (Optional)"
                  />
              </div>
              {/* <input className="w-full rounded-lg border border-slate-300 p-2 bg-slate-50 focus:outline-none" 
              value={getSelectedCustomer().Address1} placeholder="Address" readOnly /> */}
              <textarea
  className="w-full rounded-lg border border-slate-300 p-2 py-1.5 bg-slate-50 focus:outline-none resize-none leading-relaxed"
  value={getSelectedCustomer().Address1 || ''}
  placeholder="Address"
  readOnly
  rows={2}
  onInput={(e) => {
    e.target.style.height = 'auto';
    e.target.style.height = `${e.target.scrollHeight}px`;
  }}
/>
             <div className="grid grid-cols-1 sm:grid-cols-3 gap-1">
  <input className="rounded-lg border border-slate-300 px-2 py-1.5 bg-slate-50 focus:outline-none text-sm" value={getSelectedCustomer().Area} placeholder="Area" readOnly />
  <input className="rounded-lg border border-slate-300 px-2 py-1.5 bg-slate-50 focus:outline-none text-sm" value={getSelectedCustomer().Route1} placeholder="Route1" readOnly />
  <input className="rounded-lg border border-slate-300 px-2 py-1.5 bg-slate-50 focus:outline-none text-sm" value={getSelectedCustomer().Route2} placeholder="Route2" readOnly />
</div>
            </div>
        </div>

        <div className="rounded-2xl bg-white p-5 shadow-lg">
          <h2 className="mb-2 text-lg font-semibold border-b pb-1 text-orange-600">Payment Details</h2>
          <div className="space-y-2">
            <div className="relative w-full" ref={dropdownRefPaymode}>
              <label className="block mb-1 font-semibold text-gray-700">Pay Mode</label>
              <input
                type="text"
                value={searchTextPaymode}
                onChange={(e) => {
                  setSearchTextPaymode(e.target.value);
                  setDropdownOpenPaymode(true);
                  setActiveIndexPaymode(-1);
                }}
                onClick={() => setDropdownOpenPaymode(!dropdownOpenPaymode)}
                onKeyDown={handleKeyDownPaymode}
                placeholder="Search by pay mode..."
                className="w-full px-4 py-2 border rounded-md cursor-pointer focus:ring-2 focus:ring-orange-300"
              />
              {dropdownOpenPaymode && (
                <ul ref={listRefPaymode} className="absolute z-10 w-full mt-1 overflow-y-auto bg-white border rounded-md shadow-lg max-h-60">
                  {filteredPaymodes?.length > 0 ? (
                    filteredPaymodes.map((m, index) => (
                      <li
                        key={m.Mode}
                        onClick={() => {
                          setState(prev => ({...prev, payMode: m.Mode}));
                          setSearchTextPaymode(m.Mode);
                          setDropdownOpenPaymode(false);
                          setActiveIndexPaymode(-1);
                        }}
                        onMouseEnter={() => setActiveIndexPaymode(index)}
                        className={`px-4 py-2 cursor-pointer ${
                          index === activeIndexPaymode
                            ? "bg-gray-100 font-semibold"
                            : "hover:bg-orange-100"
                        }`}
                      >
                        {highlightText(m.Mode, searchTextPaymode)}
                      </li>
                    ))
                  ) : (
                    <li className="px-4 py-2 text-gray-500">No pay modes found</li>
                  )}
                </ul>
              )}
            </div>
            <input
              className="w-full rounded-lg border border-slate-300 p-2 py-1.5 focus:border-orange-500 focus:ring-1 focus:ring-orange-500"
              value={transNo}
              onChange={(e) => setTransNo(e.target.value)}
              placeholder="Transaction No (Optional)"
            />

            <input
              type="number"
              step="0.01"
              inputMode="decimal"
              onWheel={(e) => e.target.blur()}
              value={prePaidAmt}
              onChange={(e) => setPrePaidAmt(parseFloat(e.target.value) || 0)}
              className="w-full rounded-lg border border-slate-300 p-2 py-1.5 text-right font-semibold focus:border-orange-500 focus:ring-1 focus:ring-orange-500
                         [appearance:textfield]
                         [&::-webkit-outer-spin-button]:appearance-none
                         [&::-webkit-inner-spin-button]:appearance-none"
              placeholder="Prepaid Amount (₹)"
            />
          </div>
        </div>
      </div>
    );
  };

  const renderMealTypeSelection = () => {
    const types = ['Breakfast', 'Lunch', 'Dinner', 'Others'];
    const buttons = types.map(m => (
      <button
        key={m}
        onClick={() => setMealType(m)}
        className={`rounded-full px-6 py-2 text-sm font-medium transition duration-150 shadow-md ${
          state.mealType === m ? 'bg-orange-500 text-white shadow-orange-300/50' : 'bg-white text-slate-700 hover:bg-orange-50 hover:text-orange-700'
        }`}
      >
        {m}
      </button>
    ));

    return (
      <div className="my-3 flex flex-wrap gap-3">
        {buttons}
      </div>
    );
  };

  const renderItemEntry = () => {
    return (
      <div className="rounded-2xl bg-white p-3 shadow-lg">
        <h2 className="mb-1 text-lg font-semibold border-b pb-1 text-orange-600">Add Item to Order</h2>
        <div className="space-y-4">
          <div className="grid gap-4 md:grid-cols-6 items-end">
            <div className="md:col-span-2 relative" ref={dropdownRefItem}>
              <label className="mb-1 block text-xs font-medium text-slate-500">Item</label>
              <input
                type="text"
                value={searchTextItem}
                onChange={(e) => {
                  setSearchTextItem(e.target.value);
                  setDropdownOpenItem(true);
                  setActiveIndexItem(-1);
                }}
                onClick={() => setDropdownOpenItem(!dropdownOpenItem)}
                onKeyDown={handleKeyDownItem}
                placeholder="Search by item..."
                className="w-full px-4 py-2 border rounded-md cursor-pointer focus:ring-2 focus:ring-orange-300 bg-slate-50"
              />
              {dropdownOpenItem && (
                <ul ref={listRefItem} className="absolute z-10 w-full mt-1 overflow-y-auto bg-white border rounded-md shadow-lg max-h-60">
                  {filteredItems?.length > 0 ? (
                    filteredItems.map((i, index) => (
                      <li
                        key={i.ItemId}
                        onClick={async () => {
                          setSelectedItem(i);
                          setSearchTextItem(i.Item);
                          setItemDesc(i.Item_desc1);
                          setRate(i.StandardCost);
                          setAdlDC(i.DCAPPLY);
                          setDropdownOpenItem(false);
                          setActiveIndexItem(-1);
                          try {
                            const response = await api.GetpackTypevaluesAPI(i.ItemId, 1, username);
                            if (response.GetpackTypevaluesAPIjs) {
                              setPackTypes(response.GetpackTypevaluesAPIjs.Table || []);
                            }
                          } catch (error) {
                            console.error('Error fetching pack types:', error);
                          }
                        }}
                        onMouseEnter={() => setActiveIndexItem(index)}
                        className={`px-4 py-2 cursor-pointer ${
                          index === activeIndexItem
                            ? "bg-gray-100 font-semibold"
                            : "hover:bg-orange-100"
                        }`}
                      >
                        {highlightText(i.Item_desc1, searchTextItem)}
                      </li>
                    ))
                  ) : (
                    <li className="px-4 py-2 text-gray-500">No items found</li>
                  )}
                </ul>
              )}
            </div>
            <div className="md:col-span-2">
              <label className="mb-1 block text-xs font-medium text-slate-500">Item Desc</label>
              <input
                className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-orange-500 focus:ring-1 focus:ring-orange-500"
                value={itemDesc}
                readOnly
                onChange={(e) => setItemDesc(e.target.value)}
                placeholder="Custom Description (Optional)"
              />
            </div>
            <div>
              <label className="mb-1 block text-xs font-medium text-slate-500">Qty</label>
             <input
  type="number"
  min="1"
  value={qty}
  onChange={(e) => setQty(e.target.value)}
  onWheel={(e) => e.target.blur()}
  className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm text-right
             focus:border-orange-500 focus:ring-1 focus:ring-orange-500
             [appearance:textfield]
             [&::-webkit-outer-spin-button]:appearance-none
             [&::-webkit-inner-spin-button]:appearance-none"
  placeholder="Qty"
/>
            </div>
            <div>
              <label className="mb-1 block text-xs font-medium text-slate-500">Rate</label>
              <input
  type="number"
  value={rate}
  onChange={(e) => setRate(e.target.value)}
  onWheel={(e) => e.target.blur()}
  className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm text-right
             focus:border-orange-500 focus:ring-1 focus:ring-orange-500
             [appearance:textfield]
             [&::-webkit-outer-spin-button]:appearance-none
             [&::-webkit-inner-spin-button]:appearance-none"
  placeholder="Rate"
/>
            </div>
          </div>
          <div className="grid gap-4 md:grid-cols-3 items-end">
            <div>
              <label className="mb-1 block text-xs font-medium text-slate-500">AdlDC</label>
             <input
  type="number"
  value={adlDC}
  onChange={(e) => setAdlDC(e.target.value)}
  onWheel={(e) => e.target.blur()}
  className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm text-right
             focus:border-orange-500 focus:ring-1 focus:ring-orange-500
             [appearance:textfield]
             [&::-webkit-outer-spin-button]:appearance-none
             [&::-webkit-inner-spin-button]:appearance-none"
  placeholder="AdlDC"
/>
            </div>
            <div>
              <label className="mb-1 block text-xs font-medium text-slate-500">PackType</label>
              <select value={packType} onChange={(e) => setPackType(e.target.value)} className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-orange-500 focus:ring-1 focus:ring-orange-500 appearance-none bg-white">
                <option disabled value="">Select PackType</option>
                {packTypes.map(p => <option key={p.packid} value={p.packdesc}>{p.packdesc}</option>)}
              </select>
            </div>
            <div className="flex items-center">
              <label className="mb-1 block text-xs font-medium text-slate-500 mr-2">Strict Packtype</label>
              <input type="checkbox" checked={strictPacktype} onChange={(e) => setStrictPacktype(e.target.checked)} className="w-4 h-4" />
            </div>

          </div>
        </div>
       
   <div className="flex flex-col gap-2 mt-0.5 sm:flex-row sm:items-end">

  {/* Start Date */}
  <div className="flex flex-col">
    <label className="mb-1 text-xs font-medium text-slate-500">
      Start Date
    </label>
    <input
      type="date"
      id="order-date-input"
      value={state.orderDate}
      onChange={(e) => setOrderDate(e.target.value)}
      className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-orange-500 focus:ring-1 focus:ring-orange-500"
      title="Order Start Date"
    />
  </div>

  {/* Next Days */}
  <div className="flex flex-col">
    <label className="mb-1 text-xs font-medium text-slate-500">
      Next Days
    </label>
   <input
  type="number"
  value={nextDays}
  onChange={(e) => setNextDays(parseInt(e.target.value) || 1)}
  onWheel={(e) => e.target.blur()}
  className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm text-right
             focus:border-orange-500 focus:ring-1 focus:ring-orange-500
             [appearance:textfield]
             [&::-webkit-outer-spin-button]:appearance-none
             [&::-webkit-inner-spin-button]:appearance-none"
/>
  </div>

  {/* Spacer pushes button to right */}
  <div className="flex-1"></div>

  {/* Add Item Button */}
  <div className="flex items-center">
    <button
      onClick={() => {
        const newItem = {
          ItemId: selectedItem?.ItemId,
          food: state.mealType,
          item: searchTextItem,
          desc: itemDesc,
          qty: parseInt(qty) || 0,
          rate: parseFloat(rate) || 0,
          total: (parseInt(qty) || 0) * (parseFloat(rate) || 0),
          adlDC: parseFloat(adlDC) || 0,
          packType,
          strictPacktype: strictPacktype ? 1 : 0,
          notes: ''
        };
        setOrderItems(prev => [...prev, newItem]);
        // Reset form
        setSearchTextItem('');
        setItemDesc('');
        setQty(1);
        setRate('');
        setAdlDC('');
        setPackType('');
        setStrictPacktype(false);
        setPackTypes([]);
      }}
      className="flex items-center justify-center rounded-full bg-orange-500 px-7 py-2 text-sm font-semibold text-white shadow-md shadow-orange-300/40 transition hover:bg-orange-600"
    >
      Add Item
    </button>
  </div>

</div>

      </div>
   
    );
  };

  const renderItemsTable = () => {
    const netTotal = calculateNetTotal();
    const rows = orderItems.map((i, idx) => (
      <tr key={idx} className="border-b border-slate-100 hover:bg-orange-50 transition duration-100">
  <td className="p-2 text-center">
    <button
      onClick={() => removeItem(idx)}
      title="Remove item"
      className="text-red-500 hover:text-red-700"
    >
      🗑️
    </button>
  </td>
        <td className="p-2 font-medium">{i.food}</td>
        <td className="p-2">{i.item}</td>
        <td className="p-2 text-slate-500 hidden sm:table-cell">{i.desc}</td>
        <td className="p-2 text-center">
          <div className="flex items-center justify-center space-x-1">
            <button
              onClick={() => updateQty(idx, Math.max(0, i.qty - 1))}
              className="px-2 py-1 bg-gray-200 hover:bg-gray-300 rounded text-sm font-medium"
            >
              -
            </button>
            <input
              type="number"
              min="0"
              value={i.qty}
              onChange={(e) => updateQty(idx, e.target.value)}
              onWheel={(e) => e.target.blur()}
              className="w-12 text-center border border-gray-300 rounded px-1 py-1 text-sm [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
            />
            <button
              onClick={() => updateQty(idx, i.qty + 1)}
              className="px-2 py-1 bg-gray-200 hover:bg-gray-300 rounded text-sm font-medium"
            >
              +
            </button>
          </div>
        </td>
        <td className="p-2 text-right hidden md:table-cell">
        <input
  type="number"
  value={i.rate}
  onChange={(e) => updateRate(idx, e.target.value)}
  onWheel={(e) => e.target.blur()}
  className="w-16 text-right rounded border border-slate-300 p-1
             focus:border-orange-500 focus:ring-1 focus:ring-orange-500
             [appearance:textfield]
             [&::-webkit-outer-spin-button]:appearance-none
             [&::-webkit-inner-spin-button]:appearance-none"
/>
        </td>
        <td className="p-2 text-right">{i.adlDC}</td>
        <td className="p-2">{i.packType}</td>
        <td className="p-2 text-center">{i.strictPacktype}</td>
        <td className="p-2"><input value={i.notes} onChange={(e) => updateNotes(idx, e.target.value)} className="w-full rounded border border-slate-300 p-1 focus:border-orange-500 focus:ring-1 focus:ring-orange-500" /></td>
      </tr>
    ));

    return (
     <div className="mt-1 rounded-2xl bg-white p-4 shadow-lg overflow-x-auto">
        <h2 className="mb-3 text-lg font-semibold border-b pb-2 text-orange-600">Order Items</h2>
        <table className="min-w-full text-sm border-collapse">
          <thead className="bg-slate-100">
            <tr className="border-b border-slate-300">
  <th className="p-2 text-center font-medium text-slate-600 w-10 rounded-tl-xl"></th>
              <th className="p-2 text-left font-medium text-slate-600">Type</th>
              <th className="p-2 text-left font-medium text-slate-600">Item</th>
              <th className="p-2 text-left font-medium text-slate-600 hidden sm:table-cell">Description</th>
              <th className="p-2 text-center font-medium text-slate-600">Qty</th>
              <th className="p-2 text-right font-medium text-slate-600 hidden md:table-cell">Rate</th>
              <th className="p-2 text-right font-medium text-slate-600">AdlDC</th>
              <th className="p-2 text-left font-medium text-slate-600">PackType</th>
              <th className="p-2 text-center font-medium text-slate-600">Strict</th>
              <th className="p-2 text-left font-medium text-slate-600 rounded-tr-xl">Notes</th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
          <tfoot className="bg-slate-100 border-t-2 border-orange-500">
            <tr>
              <td colSpan="7" className="p-2 text-right text-base font-semibold hidden sm:table-cell">NET TOTAL:</td>
              <td colSpan="5" className="p-2 text-right text-base font-semibold sm:hidden">NET TOTAL:</td>
              <td className="p-2 text-right text-base font-bold text-orange-500" colSpan="5">₹ {netTotal}.00</td>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  };

  // const renderSummary = () => {
  //   const netTotal = calculateNetTotal();
  //   return (
  //     <div className="mt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between rounded-2xl bg-white p-5 shadow-lg">

  //       <div className="mt-4 sm:mt-0 text-right">
  //         <p className="text-sm text-slate-500">Order Value</p>
  //         <p className="text-3xl font-extrabold text-orange-500">₹ {netTotal}.00</p>
  //       </div>
  //     </div>
  //   );
  // };

  return (
    <div className="bg-slate-100 font-sans">
      <Header onLogout={handleLogout} />
      <div className="p-4 sm:p-6 md:ml-64">
        {renderHeader()}
        {renderCustomerPayment()}
        {renderMealTypeSelection()}
        {renderItemEntry()}
        {renderItemsTable()}
        {/* {renderSummary()} */}
      </div>
    </div>
  );
}
